'use strict'

export default {
  getDeposit (cb, errorCb, request = '') {
    axios.get(`/request/deposit/vizpay${request}`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postDeposit (cb, errorCb, request = {}) {
    axios.post(`/request/deposit/vizpay`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postDepositIntellient (cb, errorCb, request = {}) {
    axios.post(`/request/vizpay`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postDepositIntellientReseet (cb, errorCb, request = {}) {
    axios.post(`/request/vizpay/reset`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin/api/request.js